<div class="row justify-content-center">
  <div class="col-lg-8 content-area">
    <div class="page-card">
      <div id="openaccountingperiod">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'openaccountingperiod'">Accounting Period</h2>
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'OpenAccountingPeriod'">Open Accounting Period</h2>

        <p class="f-s-14">
          After completing the charity setup, select ‘Yes’ for open the Accounting Period option to create the first accounting period.
        </p>

        <img class="doc-screenshot" src="../../../../assets/images/logos/charitycreation.png" />

        <p class="f-s-14">
          If you choose not to start the accounting period immediately after completing the charity setup, select View Charity to access the Charity Overview page.
        </p>

        <p class="f-s-14">
          You can create the accounting period later from the ‘Financial Periods’ tab.
        </p>

        <img style="height: 400px" src="../../../../assets/images/logos/greenfields_community.png" />

        <p class="f-s-14">
          Click the ‘Open Period’ option, as shown below,
        </p>

        <img style="height: 120px" src="../../../../assets/images/logos/actions.png" />

        <p class="f-s-14">
          to open the selected accounting period.
        </p>
      </div>

      <div id="edit-accounting-period">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'edit-accounting-period'">Edit Accounting Period</h2>

        <p class="f-s-14">
          To edit the accounting period details, click Edit Details in the ‘Actions’. You can update the End Date, Accounting Method, Accounting Template, Report Type, and Fund Tracking settings.
        </p>

        <img style="height: 450px" src="../../../../assets/images/logos/editnew.jpg" /><br />

        
        <p class="f-s-14">
          You can make the required changes &amp; save the edited details by clicking on <img class="doc-button" src="../../../../assets/images/logos/update.jpg" />
        </p>
      </div>

      <div id="delete-accounting-period">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'delete-accounting-period'">Delete Accounting Period</h2>

        <p class="f-s-14">
          You can delete the period by clicking on the <img src="../../../../assets/images/logos/delete.png" /> option in Financial Periods.
        </p>


        <p class="f-s-14">
          “The Accounting Period cannot be deleted after Finalise.”
        </p>

        <p class="f-s-14">
          Once the accounting period has been opened for the selected charity, the Basic Information page is displayed.
        </p>
      </div>

      <div id="basic-information">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'basic-information'">Basic Information</h2>

        

        <p class="f-s-14">
          The Basic Information page displays the details of the selected accounting period, including the accounting period dates, accounting method, accounting template, report type, and fund tracking settings.
        </p>

        <p class="f-s-14">
          You can review these details and, where permitted, update them using the Edit Details option.
        </p>


        <img class="doc-screenshot" src="../../../../assets/images/logos/greenfieldccommunittytrust1.jpg" />

        <p class="f-s-14">
          You can update the Basic Information by clicking <img class="doc-icon" src="../../../../assets/images/logos/editdetails.png" /> in the top-right corner of the page.
        </p>



        <p class="f-s-14">
          To delete the charity, click the  <img src="../../../../assets/images/logos/click.png" /> &amp; click on <img src="../../../../assets/images/logos/deletecharity.png" />
        </p>


        <p class="f-s-14">
          After clicking ‘Next’ in ‘Basic Information’, you will be navigated to ‘Trial Balance’.
        </p>
      </div>

      <div id="trialBalanceToggle">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'trialBalanceToggle'">Trial Balance</h2>

        <p class="f-s-14">
          A trial balance is a summary report of all ledger account balances at a specific date, showing income, expenditure, assets, liabilities, and funds. Its purpose is to confirm that total debits equal total credits, ensuring the accuracy of bookkeeping records.
        </p>

        <p class="f-s-14">
          In this you have to make entry of Trial Balance for the current period. You can enter it manually or import a CSV or Excel File.
        </p>
      </div>

      <div id="import-trial-balance">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'import-trial-balance'">Import Trial Balance</h2>

        <p class="f-s-14">
          Option to import Trial balance will be in the upper right corner.
        </p>

        <img class="doc-screenshot" style="max-width:895px" src="../../../../assets/images/logos/trailblance.png" />

        <p class="f-s-14">
          Click on ‘Import’ and select the required CSV or Excel file to upload the data.
        </p>

        <p class="f-s-14">
          A Sample File is available to help you format the data correctly before importing. You can download the sample template by clicking on ‘Download a Sample File’.
        </p>

        <img class="doc-screenshot" src="../../../../assets/images/logos/importtrailbance.jpg" />

        <p class="f-s-14">
          You can review and verify the field mappings in the ‘Data Mapping’ section to ensure that the imported data is mapped correctly.
        </p>
        <img src="../../../../assets/images/logos/uploadfile.jpg" />
        <p class="f-s-14">
          Click on ‘Next’ to proceed. A ‘Preview’ section will be displayed, allowing you to review the data before completing the import process.
        </p>
        <img src="../../../../assets/images/logos/Preview.png" />
        <p class="f-s-14">
          The ‘Preview’ section allows you to review the imported data. You must resolve and balance any differences before proceeding further. Once the difference is balanced, the available options will be displayed to continue with the import process.
        </p>

        <p class="f-s-14">
          After clicking on ‘Import’, the Trial Balance will be imported successfully.
        </p>
      </div>

      <div id="balance-status">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'balance-status'">Balance Status</h2>

        <p class="f-s-14">
          If the ‘Fund Tracking’ option is disabled, the ‘Debit’ and ‘Credit’ columns will be displayed with the respective fields.
        </p>

        <img style="max-width: 895px;" src="../../../../assets/images/logos/Particulardescription.png" />

        <p class="f-s-14">
          If the ‘Fund Tracking’ option is enabled, the following columns will be displayed: ‘Unrestricted Debit’, ‘Unrestricted Credit’, ‘Restricted Debit’, ‘Restricted Credit’, ‘Endowment Debit’, and ‘Endowment Credit’.
        </p>
        <img style="max-width: 895px;" src="../../../../assets/images/logos/Balancestatus.png" />
        <p class="f-s-14">
          If the Trial Balance is Unbalanced, you can’t move to the next section.
        </p>

        <p class="f-s-14">
          You must ensure that the Trial Balance is balanced before proceeding. Once the Trial Balance is balanced, click on <img style="max-width: 895px;" src="../../../../assets/images/logos/next button.jpg" />
        </p>

        
      </div>

      <div id="trial-balance-preview">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'trial-balance-preview'">Preview</h2>

        <p class="f-s-14">
          You have an option to preview the Trial Balance Report.
        </p>

        <p class="f-s-14">
          And you will have below mentioned options:
        </p>
        <ol class="sub-feature-list2">
          <li>
            Toggle Sidebar- You can select and view any page of the report.
            <br>
            
            <img src="../../../../assets/images/logos/togglesidebar.png" 
                 alt="Toggle Sidebar"
                 style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" />
          </li>
          <li>
            Find in document- You search any particular part from the report.


            <img src="../../../../assets/images/logos/findindocument.jpg" />
          </li>
          <li>
            
            Previous &amp; Next Page- You can jump to the previous and next page. <img src="../../../../assets/images/logos/prevnextpage.png" />

          </li>

          <li>
            Automatic Zoom- You can zoom in or zoom out with this option


            <img src="../../../../assets/images/logos/automaticzoom.jpg" />
          </li>

          <li> Switch to Presentation Mode- You can switch the report to the presentation mode  <img src="../../../../assets/images/logos/view.jpg" /></li>



          <li> Open File- You can open file on the system <img src="../../../../assets/images/logos/open.png" /></li>



          <li> Print &amp; Download- You can print &amp; download the report <img src="../../../../assets/images/logos/printdownload.png" /></li>



          <li> Current View- You can copy or open the current view in new tab <img src="../../../../assets/images/logos/save.jpg" /></li>



          <li>
            Tools- You have mentioned options in the tools
            <br>

            <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;"  src="../../../../assets/images/logos/optiontools.png" />
          </li>
        </ol>
</div>
      
      <div id="trial-balance-send-mail">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'trial-balance-send-mail'">Send Mail</h2>

        <p class="f-s-14">
          You can send the report via email, if the Email is configured. By clicking on the option on <img src="../../../../assets/images/logos/email.png" /> Upper right corner.
        </p>
      </div>

      <div id="statementoffinancialtoggle">
        <h2 id="statementoffinancialtoggle"
            class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'statementoffinancialtoggle'">
          Statement of Financial Activities
        </h2>

        <p class="f-s-14">
          The SoFA records all the incoming resources and resources expended by the charity in the financial year. The SoFA is divided into columns and rows which are numbered. A summary is provided of what should be entered into each column and row.
        </p>

        <p class="f-s-14">
          You have to enter values based on the Fund Tracking you have selected.
        </p>


        <div>
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'Preview'">Preview</h2>

          <p class="f-s-14">
            You have an option to preview the Statement of Financial Activities.
          </p>

          <p class="f-s-14">
            And you will have below mentioned options:
          </p>
          <ol class="sub-feature-list2">
            
            <li>
              Toggle Sidebar- You can select and view any page of the report.

              <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/viewpagereport.png" />
            </li>

           
              <li>
                Find in document- You search any particular part from the report.



                <img src="../../../../assets/images/logos/Finddocument2.jpg" />
              </li>

            
              <li>Previous &amp; Next Page- You can jump to the previous and next page.  <img src="../../../../assets/images/logos/prevnextpage.png" /></li>
           

            
              <li>Automatic Zoom- You can zoom in or zoom out with this option <img src="../../../../assets/images/logos/automaticzoom.jpg" /></li>
            

            
              <li>Switch to Presentation Mode- You can switch the report to the presentation mode <img src="../../../../assets/images/logos/view.jpg" /></li>
            

            
              <li>Open File- You can open file on the system <img src="../../../../assets/images/logos/open.png" /></li>
            

            
              <li>Print &amp; Download- You can print &amp; download the report <img src="../../../../assets/images/logos/printdownload.png" /></li>
           

            
              <li>Current View- You can copy or open the current view in new tab <img src="../../../../assets/images/logos/save.jpg" /></li>
            

            
              <li>
                Tools- You have mentioned options in the tools


                <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/optiontools.png" />
              </li>
          </ol>
        </div>

        <div>
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'SendMail'">Send Mail</h2>

          <p class="f-s-14">
            You can send the report via email, if the Email is configured. By clicking on the option on <img src="../../../../assets/images/logos/email.png" /> Upper right corner.
          </p>

          <p class="f-s-14">
            Once you have entered all the necessary values click on ‘Next’.
          </p>
        </div>
      </div>

      <div id="receiptsPaymentsToggle">
        <h2 id="receiptsPaymentsToggle"
            class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'receiptsPaymentsToggle'">
          Receipts & Payments
        </h2>

        <p class="f-s-14">
          If you select Cash (Receipts & Payments) as the Accounting Method, the accounts will be prepared using the Receipts & Payments basis.
        </p>


        <div>
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'Preview'">Preview</h2>

          <p class="f-s-14">
            You have an option to preview the Receipts & Payments.
          </p>

          <p class="f-s-14">
            And you will have below mentioned options:
          </p>

          <ol class="sub-feature-list2">
            <li>
              Toggle Sidebar- You can select and view any page of the report.


             <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/viewpagereport.png" />
            </li>


            <li>
              Find in document- You search any particular part from the report.



              <img src="../../../../assets/images/logos/Finddocument2.jpg" />
            </li>


            <li>
              Previous &amp; Next Page- You can jump to the previous and next page.
              <img src="../../../../assets/images/logos/prevnextpage.png" />
            </li>



            <li>
              Automatic Zoom- You can zoom in or zoom out with this option
              <img src="../../../../assets/images/logos/automaticzoom.jpg" />
            </li>



            <li>
              Switch to Presentation Mode- You can switch the report to the presentation mode
              <img src="../../../../assets/images/logos/view.jpg" />
            </li>



            <li>
              Open File- You can open file on the system
              <img src="../../../../assets/images/logos/open.png" />
            </li>



            <li>
              Print &amp; Download- You can print &amp; download the report
              <img src="../../../../assets/images/logos/printdownload.png" />
            </li>



            <li>
              Current View- You can copy or open the current view in new tab
              <img src="../../../../assets/images/logos/save.jpg" />
            </li>



            <li>
              Tools- You have mentioned options in the tools


              <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/optiontools.png" />
            </li>
          </ol>
        </div>

        <div>
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'SendMail'">Send Mail</h2>

          <p class="f-s-14">
            You can send the report via email, if the Email is configured. By clicking on the option on <img src="../../../../assets/images/logos/email.png" /> Upper right corner.
          </p>

          <p class="f-s-14">
            Once you have entered all the necessary values click on ‘Next’.
          </p>
        </div>
      </div>


      <div id="balanceSheetToggle">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'balanceSheetToggle'">Balance sheet</h2>

        <p class="f-s-14">
          The balance sheet provides a ‘snapshot’ of the charity’s assets and liabilities at the end of the financial year.
        </p>
      </div>

      <div id="balancesheetpreview">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'balancesheetpreview'">Preview</h2>

        <p class="f-s-14">
          You have an option to preview the Balance Sheet. .
        </p>

        <p class="f-s-14">
          And you will have below mentioned options:
        </p>

        <ol class="sub-feature-list2">
          <li>
            Toggle Sidebar- You can select and view any page of the report.


            <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/viewpagereport.png" />
          </li>

          <li>
            Find in document- You search any particular part from the report.



            <img src="../../../../assets/images/logos/Finddocument2.jpg" />

          </li>
          <li>
            Previous &amp; Next Page- You can jump to the previous and next page.
            <img src="../../../../assets/images/logos/prevnextpage.png" />
          </li>


          <li>
            Automatic Zoom- You can zoom in or zoom out with this option
            <img src="../../../../assets/images/logos/automaticzoom.jpg" />

          </li>

          <li>
            Switch to Presentation Mode- You can switch the report to the presentation mode
            <img src="../../../../assets/images/logos/view.jpg" />
          </li>


          <li>
            Open File- You can open file on the system
            <img src="../../../../assets/images/logos/open.png" />
          </li>


          <li>
            Print &amp; Download- You can print &amp; download the report
            <img src="../../../../assets/images/logos/printdownload.png" />
          </li>


          <li>
            Current View- You can copy or open the current view in new tab
            <img src="../../../../assets/images/logos/save.jpg" />
          </li>


          <li>
            Tools- You have mentioned options in the tools


            <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/optiontools.png" />
          </li>
        </ol>
      </div>

      <div id="balancesheetsendmail">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'balancesheetsendmail'">Send Mail</h2>

        <p class="f-s-14">
          You can send the report via email, if the Email is configured. By clicking on the option on <img src="../../../../assets/images/logos/email.png" /> Upper right corner.
        </p>

        <p class="f-s-14">
          Once you have entered all the necessary values click on ‘Next’.
        </p>
      </div>


      <div id="statementsofsssetstoggle">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'statementsofsssetstoggle'">Statements of Assets & Liabilities</h2>

        <p class="f-s-14">
          If you select Cash (Receipts & Payments) as the Accounting Method, the Statement of Assets & Liabilities provides a summary of the charity's assets and liabilities at the end of the accounting period.
        </p>
      </div>
      <div id="assetspreview">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'assetspreview'">Preview</h2>

        <p class="f-s-14">
          You have an option to preview theStatements of Assets & Liabilities.
        </p>

        <p class="f-s-14">
          And you will have below mentioned options:
        </p>

        <ol class="sub-feature-list2">
          <li>
            Toggle Sidebar- You can select and view any page of the report.


            <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/viewpagereport.png" />
          </li>


          <li>
            Find in document- You search any particular part from the report.



            <img src="../../../../assets/images/logos/Finddocument2.jpg" />
          </li>


          <li>
            Previous &amp; Next Page- You can jump to the previous and next page.
            <img src="../../../../assets/images/logos/prevnextpage.png" />
          </li>



          <li>
            Automatic Zoom- You can zoom in or zoom out with this option
            <img src="../../../../assets/images/logos/automaticzoom.jpg" />
          </li>



          <li>
            Switch to Presentation Mode- You can switch the report to the presentation mode
            <img src="../../../../assets/images/logos/view.jpg" />
          </li>



          <li>
            Open File- You can open file on the system
            <img src="../../../../assets/images/logos/open.png" />
          </li>



          <li>
            Print &amp; Download- You can print &amp; download the report
            <img src="../../../../assets/images/logos/printdownload.png" />
          </li>



          <li>
            Current View- You can copy or open the current view in new tab
            <img src="../../../../assets/images/logos/save.jpg" />
          </li>



          <li>
            Tools- You have mentioned options in the tools


            <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/optiontools.png" />
          </li>
        </ol>
      </div>
      <div id="assetssendemail">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'assetssendemail'">Send Mail</h2>

        <p class="f-s-14">
          You can send the report via email, if the Email is configured. By clicking on the option on <img src="../../../../assets/images/logos/email.png" /> Upper right corner.
        </p>

        <p class="f-s-14">
          Once you have entered all the necessary values click on ‘Next’.
        </p>
      </div>


      <div id="notesToggle">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'notesToggle'">Notes to the Accounts</h2>

        <p class="f-s-14">
          Every set of company accounts require notes which explain:
        </p>

        <p class="f-s-14">
          •	The basis on which the accounts have been prepared
        </p>

        <p class="f-s-14">
          •	The accounting policies that have been adopted which explain when assets and liabilities, income and expenditure are included in the accounts and at what value
        </p>

        <p class="f-s-14">
          •	Other information required to provide more details of what the accounting statements contain and to ensure that the accounts provide a ‘true and fair’ view.
        </p>

        <p class="f-s-14">
          In this section, you will have a total of 29 Notes.
        </p>
      </div>

      <div id="listofnotes">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'listofnotes'">List of Notes</h2>

        <p class="f-s-14">
          Following are the Notes available in the software
        </p>
        <div class="notes-list">
          <p class="f-s-14">1. Revised Statements</p>
          <p class="f-s-14">2. General Information</p>
          <p class="f-s-14">3. Accounting Policies</p>
          <p class="f-s-14">4. Analysis of Income</p>
          <p class="f-s-14">5. Analysis of Receipts of Government Grants</p>
          <p class="f-s-14">6. Donated Goods, Facilities and Services</p>
          <p class="f-s-14">7. Analysis of Expenditure</p>
          <p class="f-s-14">8. Extraordinary Items</p>
          <p class="f-s-14">9. Funds Received as Agent</p>
          <p class="f-s-14">10. Support Costs</p>
          <p class="f-s-14">11. Fees for examination of the accounts</p>
          <p class="f-s-14">12. Paid Employees</p>
          <p class="f-s-14">13. Pension Scheme</p>
          <p class="f-s-14">14. Grantmaking</p>
          <p class="f-s-14">15. Tangible Fixed Assets</p>
          <p class="f-s-14">16. Intangible Assets</p>
          <p class="f-s-14">17. Heritage Assets</p>
          <p class="f-s-14">18. Investment Assets</p>
          <p class="f-s-14">19. Stocks</p>
          <p class="f-s-14">20. Debtors and Prepayments</p>
          <p class="f-s-14">21. Creditors and Accruals</p>
          <p class="f-s-14">22. Provisions for Liabilities and Charges</p>
          <p class="f-s-14">23. Disclosures for Debtors &amp; Creditors</p>
          <p class="f-s-14">24. Contingent Liabilities and Contingent Assets</p>
          <p class="f-s-14">25. Cash and Cash Equivalents</p>
          <p class="f-s-14">26. Fair Value of Assets and Liabilities</p>
          <p class="f-s-14">27. Events after the end of the Reporting Period</p>
          <p class="f-s-14">28. Charity Funds</p>
          <p class="f-s-14">29. Transactions with Trustees and Related Parties</p>
          <p class="f-s-14">30. Additional Disclosures</p>
          </div>
        </div>

        <div id="selectallnotes">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'selectallnotes'">Select All Notes</h2>

          <p class="f-s-14">
            If you want to include all notes, you can select the <img class="selectall" src="../../../../assets/images/logos/selectall.jpg" />
          </p>

          <p class="f-s-14">
            Alternatively, you can select specific notes individually. However, Note 1, Note 2, and Note 11 are mandatory and must be included.
          </p>
        </div>

        <div id="jumptosection">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'jumptosection'">Jump to section</h2>

          <p class="f-s-14">
            You can directly jump to a particular note from the selected notes.
          </p>

          <p class="f-s-14">
            After selecting notes, you can click on the <img src="../../../../assets/images/logos/Continuewithselectednotes.png" /> option. It will have the count of notes selected by you.
          </p>
        </div>

        <div id="defaultstatement">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'defaultstatement'">Default Statement</h2>

          <p class="f-s-14">
            This option is available for some of the notes where you need to mention some details in brief.
          </p>

          <p class="f-s-14">
            You can select this option  <img src="../../../../assets/images/logos/defaultstatement.png" />, in the upper right corner of the note and a default statement for the particular note will be available.
          </p>
        </div>

        <div id="addfunctionality">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'addfunctionality'">Add Functionality</h2>

          <p class="f-s-14">
            This option is available for selected notes where you need to mention some extra details or some extra information then you have to click on  <img class="doc-button" src="../../../../assets/images/logos/addlightbutton.png" />, and mention the required details in the form.
          </p>
        </div>

        <div id="navigation">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'navigation'">Navigation</h2>

          <p class="f-s-14">
            You can enter the details and save the data by clicking on ‘Save as Draft’, and you can navigate through the notes by click ‘Back’ which will display the previous note and click on ‘Next’ then the next note will be displayed.
          </p>

          <img style="max-width: 895px;" src="../../../../assets/images/logos/savetodraft.png" />

          <p class="f-s-14">
            Once you complete all the notes click on ‘Next’.
          </p>
        </div>


        <div id="trusteesReportToggle">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'trusteesReportToggle'">Trustees Report</h2>
        </div>

        <div id="trusteesannualreport">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'trusteesannualreport'">Trustees Annual Report</h2>

          <p class="f-s-14">
            A Trustees’ Annual Report (TAR) is a legally required document. It is the narrative section of the annual accounts, complementing the financial statements. Required under the Charities Act 2011 and the Charities SORP (FRS 102).
          </p>

          <p class="f-s-14">
            You will have an option to include Trustees Annual Report,
          </p>

          <p class="f-s-14">
            If you select ‘Yes’ then you will have to fill the details mentioned in all the five sections.
          </p>

          <img class="doc-screenshot" src="../../../../assets/images/logos/trusteesreport.png" />

          <p class="f-s-14">
            If you don’t want to include then select ‘No’ &amp; click on ‘Next’.
          </p>
        </div>



        <div id="trusteeResponsibilityToggle">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'trusteeResponsibilityToggle'">
            Statement of Trustees Responsibility
          </h2>

          <h3 class="f-s-18 f-w-600 m-t-16">
            Default Statement
          </h3>

          <p class="f-s-14">
            You will have an option to include the statement of Trustees Responsibility, if you select ‘Yes’
          </p>
          <p class="f-s-14">
            This option is available &amp; the default statement will be mentioned.
          </p>

          <img class="doc-screenshot" src="../../../../assets/images/logos/statementof trustees responsibility.png" />

          <p class="f-s-14">
            If you don’t want to include then select ‘No’ &amp; click on ‘Next’.
          </p>

          <p class="f-s-14">
            You have to select either one from ‘Trustees Annual Report’ or ‘Statement of Trustees Responsibility’ then only you can fill the ‘Trustee Declaration’.
          </p>
        </div>

        <div id="trusteesdefaultstatement">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'trusteesdefaultstatement'">Default Statement</h2>

          <p class="f-s-14">
            This option is available & the default statement will be mentioned.
          </p>
          <img src="../../../../assets/images/logos/statementoflastimage.png" />
          <p class="f-s-14">
            If you don’t want to include then select ‘No’ & click on ‘Next’.
          </p>
          <p class="f-s-14">
            You have to select either one from ‘Trustees Annual Report’ or ‘Statement of Trustees Responsibility’ then only you can fill the ‘Trustee Declaration’.
          </p>
        </div>

        <div id="trusteedeclaration">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'trusteedeclaration'">Trustee Declaration</h2>

          <p class="f-s-14">
            You will have two options where you will have to select the Trustee and the approval date.
          </p>

          <img style="max-width: 895px;" src="../../../../assets/images/logos/trustees declaration.png" />

        </div>
        <p class="f-s-14">After you fill the declaration, click on ‘Next’.</p>
        <div id="examinerReportToggle">
         <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'examinerReportToggle'">Independent Examiner’s Report</h2>

        <p class="f-s-14">
          An Independent Examiner’s Report is a formal statement prepared by an independent person who reviews a charity’s accounts when a full audit is not legally required.
        </p>

        <p class="f-s-14">
          You will have to fill the details for:
        </p>

        <p class="f-s-14">
          1. Opening Statement
        </p>

        <p class="f-s-14">
          2. Responsibilities and basis of report
        </p>

        <p class="f-s-14">
          3. Independent Examiner’s Statement
        </p>

        <p class="f-s-14">
          4. Declaration
        </p>
      </div>

      <div id="independentexaminerdefaultstatement">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'independentexaminerdefaultstatement'">Default Statement</h2>

        <p class="f-s-14">
          This option is available & the default statement will be mentioned.
        </p>

      </div>

      <div id="AuditorsReportToggle">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'AuditorsReportToggle'">Auditors report</h2>

        <p class="f-s-14">
          If Auditor is selected as the Report Type, the accounts will include an Auditor's Report. The report provides the auditor's independent opinion on the charity's financial statements and whether they have been prepared in accordance with the applicable accounting and reporting requirements.
          The Auditor's Report forms part of the charity's financial statements and is included in the final accounts.
        </p>

        <p class="f-s-14">
          You will have to fill the details for:
        </p>

          <p class="f-s-14">
            1. Opinion: This section allows you to select the auditor's opinion on the charity's financial statements: Qualified or Unqualified.
          </p>

        <p class="f-s-14">
          2. Basis for Opinion
        </p>

        <p class="f-s-14">
          3. Conclusions relating to going concern
        </p>

        <p class="f-s-14">
          4. Other information
        </p>

        <p class="f-s-14">
          5. Opinions on other matters prescribed by the Companies Act 2006: This section will be available if report type is <strong>Auditor</strong> & <strong>Companies Act 2006</strong> is selected as audited in basic information.
        </p>

        <p class="f-s-14">
          6. Matters on which we are required to report by exception.
        </p>

        <p class="f-s-14">
          7. Responsibilities of trustees
        </p>

        <p class="f-s-14">
          8. Auditor's responsibility for the audit of the financial statements
        </p>

        <p class="f-s-14">
          9. Use of this report
        </p>

        <p class="f-s-14">
          10. Declaration
        </p>
      </div>

      <div id="auditorsreportdefaulttogglestatement">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'auditorsreportdefaulttogglestatement'">Default Statement</h2>

        <p class="f-s-14">
          This option is available &amp; the default statement will be mentioned.
        </p>

      </div>

      <div id="finalAccountsToggle">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'finalAccountsToggle'">
          Final Accounts
        </h2>
     

        <p class="f-s-14">
          In this section, you will be able to view the details.
        </p>

        <img class="doc-screenshot" src="../../../../assets/images/logos/Accountsections.png" />

        <p class="f-s-14">
          Account Sections- This section provides an overview of the ‘Completed’ and ‘Incomplete’ sections, allowing you to quickly identify areas that require attention and navigate directly to complete the pending information.
        </p>

        <p class="f-s-14">
          You can click on ‘Edit’ to add the missing details or update information that has already been completed.
        </p>

        <p class="f-s-14">
          For ‘Notes’, hover over the ‘Incomplete’ status to view the list of pending notes. You can select a specific note from the list to navigate directly to it and complete the required details.
        </p>
        <img style="height:452px" src="../../../../assets/images/logos/accountsections2.png" />
        <p class="f-s-14">
          Account for the Statutory Accounts- In this section, you will find the mandatory fields, including ‘Approval Date’, ‘Name of Approver’, and the required Statement field.
        </p>
        <img class="doc-screenshot" src="../../../../assets/images/logos/Approovalof thestatutoryaccount.png" />

      </div>

      <div id="finalaccountsdefaultstatement">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'finalaccountsdefaultstatement'">Default Statement</h2>

        <p class="f-s-14">
          This option is available &amp; the default statement will be mentioned.
        </p>
        <p class="f-s-14">
          You will have Preview & Export options on the upper right corner.
          <img class="doc-button" src="../../../../assets/images/logos/previewandexport.png" />
        </p>
      </div>


      <div id="finalaccountspreview">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'finalaccountspreview'">Preview</h2>

        <p class="f-s-14">
          In this option, you will get the preview of Complete Accounts Package.
          You will have the following options:
        </p>


          <ol class="sub-feature-list2">
            <li>
              Toggle Sidebar- You can select and view any page of the report.


              <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/viewpagereport.png" />
            </li>

            <li>
              Find in document- You search any particular part from the report.



              <img src="../../../../assets/images/logos/Finddocument2.jpg" />
            </li>

            <li>
              Previous &amp; Next Page- You can jump to the previous and next page.
              <img src="../../../../assets/images/logos/prevnextpage.png" />
            </li>


            <li>
              Automatic Zoom- You can zoom in or zoom out with this option
              <img src="../../../../assets/images/logos/automaticzoom.jpg" />

            </li>

            <li>
              Switch to Presentation Mode- You can switch the report to the presentation mode
              <img src="../../../../assets/images/logos/view.jpg" />
            </li>


            <li>
              Open File- You can open file on the system
              <img src="../../../../assets/images/logos/open.png" />
            </li>


            <li>
              Print &amp; Download- You can print &amp; download the report
              <img src="../../../../assets/images/logos/printdownload.png" />
            </li>


            <li>
              Current View- You can copy or open the current view in new tab
              <img src="../../../../assets/images/logos/save.jpg" />

            </li>

            <li>
              Tools- You have mentioned options in the tools


              <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/optiontools.png" />
            </li>

            <li> Export iXBRL-  If you want to download the file in iXBRL format. .</li>
          </ol>
        </div>

      <div id="finalaccountsexport">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'finalaccountsexport'">Export</h2>

        <p class="f-s-14">
          When you click on ‘Export’, you get a pop-up for the selection of fields that you need in the file.
        </p>

        <img style="height:452px" src="../../../../assets/images/logos/Exportaccounts.jpg" />

        <p class="f-s-14">
          You will have both options to export the file in PDF or iXBRL format.
        </p>
      </div>

      <div id="finaliseaccounts">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'finaliseaccounts'">Finalise Accounts</h2>

        <p class="f-s-14">
          You can finalise the accounts once all required information has been completed.
        </p>

        <p class="f-s-14">
          A <strong>‘Ready to Finalise’</strong> indicator is available to show the completion status. It will display <strong>‘Yes’</strong>  when all forms and required information are completed. If any information is incomplete, it will display <strong>‘No’</strong>,  indicating that further action is required before finalising the accounts.
        </p>

        <img style="max-width: 895px;" src="../../../../assets/images/logos/final and closed.jpg" />

        <p class="f-s-14">
          Once you click on <strong>‘Finalise &amp; Submit Accounts’</strong>, the selected accounting period will be locked, and no further changes or edits can be made to the information for that period.
        </p>

        <p class="f-s-14">
          Clicking <strong>‘Finalise and Close’</strong> confirms that the accounts are complete and locks the accounting period, preventing any further edits.

        <p class="f-s-14">
          Once you click  <strong>‘Finalise and Close’</strong>, the accounting period will be locked for editing. You can use the  <strong>‘Unlock’</strong> option to make further changes, or click <strong>‘Submit’</strong> to proceed directly to the submission process.
        </p>
        <img style="max-width: 895px;" src="../../../../assets/images/logos/unlockk.jpg" />
        <img style="max-width: 895px;" src="../../../../assets/images/logos/readyunlock.jpg" />
        <p class="f-s-14">
          Alternatively, you can unlock the accounting period by clicking   in the Final Accounts section
        </p>
        <img style="max-width: 895px;" src="../../../../assets/images/logos/financialunlock.jpg" />
      </div>

      <div id="submissionToggle">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'submissionToggle'">Submissions</h2>

        <p class="f-s-14">
          Once the accounts are finalised, you can proceed with submitting the required reports and statements to Companies House and the Charity Commission.
        </p>

        <p class="f-s-14">
          Note: Submissions to Companies House are applicable only for Charitable Companies and Charitable Incorporated Organisations (CIOs). Unincorporated charities do not require submissions to Companies House.
        </p>
      </div>


      <div id="companyhouse">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'companyhouse'">Companies House </h2>

        <p class="f-s-14">
          If you have to submit it to Companies House, then click on ‘Submit to Companies House’
        </p>

        <img style="height:344px" src="../../../../assets/images/logos/Companieshouse.png" />

        <p class="f-s-14">
          And mention all the details,
        </p>

        <img style="height:387px" src="../../../../assets/images/logos/Companyhouse_softwarefillingdetails.jpg" />

          <ul class="sub-feature-list2">

          <li>
            <strong>Companies Registration Number</strong> - It will be fetched directly from the details.
          </li>

            <li>
              <strong>Company Authentication Code*</strong> - This is a mandatory field and also has an option to hide the code<img style="vertical-align: middle;" src="../../../../assets/images/logos/eyeicon.jpg" />
            </li>

          <li>
            <strong>Submitted As</strong> - You will have option to select from the details filled by you earlier.
          </li>

          <li>
            <strong>Presenter Contact Name</strong> - You can mention the name of presenter.
          </li>

          <li>
            <strong>Presenter ID*</strong> - This is a mandatory field.
          </li>

          <li>
            <strong>Presenter Authentication Code*</strong> - This is a mandatory field and also has an option to hide the code<img style="vertical-align: middle;" src="../../../../assets/images/logos/eyeicon.jpg" />
          </li>

          <li>
            <strong>Presenter Email Address*</strong> - This is a mandatory field and need to mention the email address.
          </li>

          <li>
            <strong>Presenter Contact Number</strong> - You can fill the contact number.
          </li>

          <li>
            <strong>Do you want to save the login credentials</strong> - If you want to save the details, you have to tick the box.
          </li>

        </ul>

        <p class="f-s-14">
          After filing all the details click on ‘Submit’, then you will get a pop-up
        </p>

        <img style="height: 162px; " src="../../../../assets/images/logos/livesubmissionpopup.png" />

        <p class="f-s-14">
          You can click on ‘OK’ to continue with the submission.
        </p>

        <p class="f-s-14">
          Then all the details of File by Internet will be seen on the screen.
        </p>

        <p class="f-s-14">
          All the File By Internet- Submission Details will be available.
        </p>

        <img style="height:380px" src="../../../../assets/images/logos/filebyinternet.jpg" />

      </div>

      <div id="amendsubmission">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'amendsubmission'">Amend Submission</h2>
        <p class="f-s-14">
          You can click on ‘Unlock & Amend Accounts’ to amend the submission details.
        </p>
        <img style="width:785px" src="../../../../assets/images/logos/periodsubmitted.jpg" />
        <p class="f-s-14">
          You have other options in the right side of the details.
        </p>
      </div>

      <div id="showerror">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'showerror'">Show Error</h2>

        <p class="f-s-14">
          If any errors occur during the submission process, the details of the errors will be displayed. You will also have the option to download the error report for further review.
        </p>
        <img style="height:462px" src="../../../../assets/images/logos/errorlogdownload.png" />
      </div>


      <div id="printfbireceipt">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'printfbireceipt'">Print FBI Receipt</h2>

        <p class="f-s-14">
          You can print the File by Internet Receipt.
        </p>

        <p class="f-s-14">
          And you will have below mentioned options:
        </p>

          <ol class="sub-feature-list2">
            <li>
              Toggle Sidebar- You can select and view any page of the report.


              <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/viewpagereport.png" />
            </li>


            <li>
              Find in document- You search any particular part from the report.



              <img src="../../../../assets/images/logos/Finddocument2.jpg" />
            </li>


            <li>
              Previous &amp; Next Page- You can jump to the previous and next page.
              <img src="../../../../assets/images/logos/prevnextpage.png" />
            </li>



            <li>
              Automatic Zoom- You can zoom in or zoom out with this option
              <img src="../../../../assets/images/logos/automaticzoom.jpg" />
            </li>



            <li>
              Switch to Presentation Mode- You can switch the report to the presentation mode
              <img src="../../../../assets/images/logos/view.jpg" />
            </li>



            <li>
              Open File- You can open file on the system
              <img src="../../../../assets/images/logos/open.png" />
            </li>



            <li>
              Print &amp; Download- You can print &amp; download the report
              <img src="../../../../assets/images/logos/printdownload.png" />
            </li>



            <li>
              Current View- You can copy or open the current view in new tab
              <img src="../../../../assets/images/logos/save.jpg" />
            </li>



            <li>
              Tools- You have mentioned options in the tools


              <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/optiontools.png" />
            </li>
          </ol>
        </div>

      <div id="downloadfbireceipt">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'downloadfbireceipt'">Download FBI Receipt</h2>

        <p class="f-s-14">
          You can directly download the FBI receipt in PDF format.
        </p>
      </div>

      <div id="viewinxml">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'viewinxml'">View in XML</h2>

        <p class="f-s-14">
          You can view the receipt in XML format.
        </p>
      </div>

      <div id="downloadinxml">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'downloadinxml'">Download in XML</h2>

        <p class="f-s-14">
          You can directly download the receipt in XML format.
        </p>
      </div>

      <div id="charitycommission">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'charitycommission'">Charity Commission</h2>

        <p class="f-s-14">
          If you want to submit the accounts to the Charity Commission, click on ‘Submit to Charity Commission’ to proceed with the submission process.
        </p>
        <img style="height:276px" src="../../../../assets/images/logos/charitycommission.png" />
        <p class="f-s-14">
          Then you will be directed to <a style="color:dodgerblue"
   href="https://my-charity-account.charitycommission.gov.uk"
   target="_blank"
   rel="noopener noreferrer">
  https://my-charity-account.charitycommission.gov.uk
</a>
        </p>

        <img style=" height: 300px;" src="../../../../assets/images/logos/signin.png" />

        <p class="f-s-14">
          Where you will have to sign with you credentials and submit the report.
        </p>
      </div>

      <div id="retrievesubmissionstatus">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'retrievesubmissionstatus'">Retrieve Submission Status</h2>

        <p class="f-s-14">
          The current status of the submission will be displayed in this section.
        </p>

        <p class="f-s-14">
          You will also have ‘Preview’ and ‘Export’ options available in the upper-right corner.
        </p>
        <img class="doc-button" src="../../../../assets/images/logos/previewandexport.png" />
      </div>

      <div id="submissionpreview">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'submissionpreview'">Preview</h2>

        <p class="f-s-14">
          In this option, you will get the preview of Complete Accounts Package.
        </p>

        <p class="f-s-14">
          And you will have below mentioned options:
        </p>

          <ol class="sub-feature-list2">
            <li>
              Toggle Sidebar- You can select and view any page of the report.

              <br>
              <img style="display: block; margin-top: 8px; max-width: 300px; height: 250px;" src="../../../../assets/images/logos/viewpagereport.png" />
            </li>


            <li>
              Find in document- You search any particular part from the report.



              <img src="../../../../assets/images/logos/Finddocument2.jpg" />
            </li>


            <li> Previous &amp; Next Page- You can jump to the previous and next page.  <img src="../../../../assets/images/logos/prevnextpage.png" /></li>



            <li> Automatic Zoom- You can zoom in or zoom out with this option <img src="../../../../assets/images/logos/automaticzoom.jpg" /></li>



            <li> Switch to Presentation Mode- You can switch the report to the presentation mode <img src="../../../../assets/images/logos/view.jpg" /></li>



            <li> Open File- You can open file on the system <img src="../../../../assets/images/logos/open.png" /></li>



            <li> Print &amp; Download- You can print &amp; download the report <img src="../../../../assets/images/logos/printdownload.png" /></li>



            <li> Current View- You can copy or open the current view in new tab <img src="../../../../assets/images/logos/save.jpg" /></li>



            <li>
              Tools- You have mentioned options in the tools


              <br>
              <img style="display:block; margin-top:8px; max-width:250px; font-size:14px; height:250px;" src="../../../../assets/images/logos/optiontools.png" />
            </li>
          </ol>
        </div>

      <div id="submissionexport">
       <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'submissionexport'">Export</h2>

        <p class="f-s-14">
          When you click on ‘Export’, you get a pop-up for the selection of fields that you need in the file.
        </p>

        <img style="height:400px" src="../../../../assets/images/logos/Exportaccounts.jpg" />

          <p class="f-s-14">
            You will have both options to export the file in PDF or iXBRL format.
          </p>
        </div>
      </div>
    </div>

  <div class="col-lg-3">

    <div class="on-page-sidebar">

      <p class="sidebar-title">On this page</p>

      <ul class="scroll-container">

        <li [class.parent-active]="[
'openaccountingperiod',
'edit-accounting-period',
'delete-accounting-period',
'basic-information'
].includes(selectedSection)">

          <div class="menu-header"
               (click)="toggleAccountingPeriodMenu()">

            Accounting Period

            <span>
              {{ accountingPeriodExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'openaccountingperiod'"
                (click)="changeSection('openaccountingperiod')">

              Open Accounting Period

            </li>

            <li [class.active]="selectedSection === 'edit-accounting-period'"
                (click)="changeSection('edit-accounting-period')">

              Edit Accounting Period

            </li>

            <li [class.active]="selectedSection === 'delete-accounting-period'"
                (click)="changeSection('delete-accounting-period')">

              Delete Accounting Period

            </li>

            <li [class.active]="selectedSection === 'basic-information'"
                (click)="changeSection('basic-information')">

              Basic Information

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
    'trialBalanceToggle',
    'import-trial-balance',
    'balance-status'
  ].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleTrialBalanceMenu()">

            Trial Balance

            <span>
              {{ trialBalanceExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'trialBalanceToggle'"
                (click)="changeSection('trialBalanceToggle')">

              Trial Balance

            </li>

            <li [class.active]="selectedSection === 'import-trial-balance'"
                (click)="changeSection('import-trial-balance')">

              Import Trial Balance

            </li>

            <li [class.active]="selectedSection === 'balance-status'"
                (click)="changeSection('balance-status')">

              Balance Status

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
  'statementoffinancialtoggle'
].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleStatementOfFinancialActivitiesMenu()">

            Statement of Financial Activities

            <span>
              {{ statementOfFinancialActivitiesExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'statementoffinancialtoggle'"
                (click)="changeSection('statementoffinancialtoggle')">

              Statement of Financial Activities

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
  'receiptsPaymentsToggle'
].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleReceiptsPaymentsMenu()">

            Receipts & Payments

            <span>
              {{ receiptsPaymentsExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'receiptsPaymentsToggle'"
                (click)="changeSection('receiptsPaymentsToggle')">

              Receipts & Payments

            </li>

          </ul>

        </li>


        <li [class.parent-active]="[
  'balanceSheetToggle'
].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleBalanceSheetMenu()">

            Balance Sheet

            <span>
              {{ balanceSheetExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'balanceSheetToggle'"
                (click)="changeSection('balanceSheetToggle')">

              Balance Sheet

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
  'statementsofsssetstoggle'
].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleStatementsOfAssetsLiabilitiesMenu()">

            Statements of Assets & Liabilities

            <span>
              {{ statementsOfAssetsLiabilitiesExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'statementsofsssetstoggle'"
                (click)="changeSection('statementsofsssetstoggle')">

              Statements of Assets & Liabilities

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
    'notesToggle',
    'listofnotes',
    'selectallnotes',
    'jumptosection',
    'defaultstatement',
    'addfunctionality',
    'navigation'
  ].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleNotesMenu()">

            Notes to the Accounts

            <span>
              {{ notesExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'notesToggle'"
                (click)="changeSection('notesToggle')">

              Notes to the Accounts

            </li>

            <li [class.active]="selectedSection === 'listofnotes'"
                (click)="changeSection('listofnotes')">

              List of Notes

            </li>

            <li [class.active]="selectedSection === 'selectallnotes'"
                (click)="changeSection('selectallnotes')">

              Select All Notes

            </li>

            <li [class.active]="selectedSection === 'jumptosection'"
                (click)="changeSection('jumptosection')">

              Jump To Section

            </li>

            <li [class.active]="selectedSection === 'defaultstatement'"
                (click)="changeSection('defaultstatement')">

              Default Statement

            </li>

            <li [class.active]="selectedSection === 'addfunctionality'"
                (click)="changeSection('addfunctionality')">

              Add Functionality

            </li>

            <li [class.active]="selectedSection === 'navigation'"
                (click)="changeSection('navigation')">

              Navigation

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
  'trusteesannualreport',
  'trusteeResponsibilityToggle',
  'trusteesdefaultstatement',
  'trusteedeclaration'
].includes(selectedSection)">
          

          <div class="submenu-parent"
               (click)="toggleTrusteesReportMenu()">

            Trustees Report

            <span>
              {{ trusteesReportExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'trusteesannualreport'"
                (click)="changeSection('trusteesannualreport')">

              Trustees Annual Report

            </li>

            <li [class.parent-active]="[
                'trusteeResponsibilityToggle',
                'trusteesdefaultstatement',
                'trusteedeclaration'
            ].includes(selectedSection)">

              <div class="submenu-parent"
                   (click)="toggleTrusteeResponsibilityMenu()">

                Statement of Trustees Responsibility

                <span>
                  {{ trusteeResponsibilityExpanded ? '−' : '+' }}
                </span>

              </div>

              <ul class="submenu-level-3">

                <li [class.active]="selectedSection === 'trusteeResponsibilityToggle'"
                    (click)="changeSection('trusteeResponsibilityToggle')">

                  Statement of Trustees Responsibility

                </li>

                <li [class.active]="selectedSection === 'trusteesdefaultstatement'"
                    (click)="changeSection('trusteesdefaultstatement')">

                  Default Statement

                </li>

                <li [class.active]="selectedSection === 'trusteedeclaration'"
                    (click)="changeSection('trusteedeclaration')">

                  Trustee Declaration

                </li>

              </ul>

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
  'examinerReportToggle',
  'independentexaminerdefaultstatement'
].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleIndependentExaminerMenu()">

            Independent Examiner's Report

            <span>
              {{ independentExaminerExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'examinerReportToggle'"
                (click)="changeSection('examinerReportToggle')">

              Independent Examiner's Report

            </li>

            <li [class.active]="selectedSection === 'independentexaminerdefaultstatement'"
                (click)="changeSection('independentexaminerdefaultstatement')">

              Default Statement

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
  'AuditorsReportToggle',
  'auditorsreportdefaulttogglestatement'
].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleAuditorsReportMenu()">

            Auditors Report

            <span>
              {{ auditorsReportExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'AuditorsReportToggle'"
                (click)="changeSection('AuditorsReportToggle')">

              Auditors Report

            </li>

            <li [class.active]="selectedSection === 'auditorsreportdefaulttogglestatement'"
                (click)="changeSection('auditorsreportdefaulttogglestatement')">

              Default Statement

            </li>

          </ul>

        </li>
        

        <li [class.parent-active]="[
  'finalAccountsToggle',
  'finalaccountsdefaultstatement',
  'finalaccountspreview',
  'finalaccountsexport',
  'finaliseaccounts'
].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleFinalAccountsMenu()">

            Final Accounts

            <span>
              {{ finalAccountsExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'finalAccountsToggle'"
                (click)="changeSection('finalAccountsToggle')">

              Final Accounts

            </li>

            <li [class.active]="selectedSection === 'finalaccountsdefaultstatement'"
                (click)="changeSection('finalaccountsdefaultstatement')">

              Default Statement

            </li>

            <li [class.active]="selectedSection === 'finalaccountspreview'"
                (click)="changeSection('finalaccountspreview')">

              Preview

            </li>

            <li [class.active]="selectedSection === 'finalaccountsexport'"
                (click)="changeSection('finalaccountsexport')">

              Export

            </li>

            <li [class.active]="selectedSection === 'finaliseaccounts'"
                (click)="changeSection('finaliseaccounts')">

              Finalise Accounts

            </li>

          </ul>

        </li>

        <li [class.parent-active]="[
  'submissionToggle',
  'companyhouse',
  'amendsubmission',
  'showerror',
  'printfbireceipt',
  'downloadfbireceipt',
  'viewinxml',
  'downloadinxml',
  'charitycommission',
  'retrievesubmissionstatus',
  'submissionpreview',
  'submissionexport'
].includes(selectedSection)">

          <div class="submenu-parent"
               (click)="toggleSubmissionsMenu()">

            Submissions

            <span>
              {{ submissionsExpanded ? '−' : '+' }}
            </span>

          </div>

          <ul 
              class="submenu-level-2">

            <li [class.active]="selectedSection === 'submissionToggle'"
                (click)="changeSection('submissionToggle')">

              Submissions

            </li>

            <li [class.parent-active]="[
                'companyhouse',
                'amendsubmission',
                'showerror',
                'printfbireceipt',
                'downloadfbireceipt',
                'viewinxml',
                'downloadinxml'
              ].includes(selectedSection)">

              <div class="submenu-parent"
                   (click)="toggleCompaniesHouseMenu()">

                Companies House

                <span>
                  {{ companiesHouseExpanded ? '−' : '+' }}
                </span>

              </div>

              <ul class="submenu-level-3">

                <li [class.active]="selectedSection === 'companyhouse'"
                    (click)="changeSection('companyhouse')">

                  Companies House

                </li>

                <li [class.active]="selectedSection === 'amendsubmission'"
                    (click)="changeSection('amendsubmission')">

                  Amend Submission

                </li>

                <li [class.active]="selectedSection === 'showerror'"
                    (click)="changeSection('showerror')">

                  Show Error

                </li>

                <li [class.active]="selectedSection === 'printfbireceipt'"
                    (click)="changeSection('printfbireceipt')">

                  Print FBI Receipt

                </li>

                <li [class.active]="selectedSection === 'downloadfbireceipt'"
                    (click)="changeSection('downloadfbireceipt')">

                  Download FBI Receipt

                </li>

                <li [class.active]="selectedSection === 'viewinxml'"
                    (click)="changeSection('viewinxml')">

                  View in XML

                </li>

                <li [class.active]="selectedSection === 'downloadinxml'"
                    (click)="changeSection('downloadinxml')">

                  Download in XML

                </li>

              </ul>

            </li>

            <li [class.active]="selectedSection === 'charitycommission'"
                (click)="changeSection('charitycommission')">

              Charity Commission

            </li>

            <li [class.active]="selectedSection === 'retrievesubmissionstatus'"
                (click)="changeSection('retrievesubmissionstatus')">

              Retrieve Submission Status

            </li>

            <li [class.active]="selectedSection === 'submissionpreview'"
                (click)="changeSection('submissionpreview')">

              Preview

            </li>

            <li [class.active]="selectedSection === 'submissionexport'"
                (click)="changeSection('submissionexport')">

              Export

            </li>

          </ul>

        </li>

      </ul>
   
    </div>

  </div>
</div>

